import { DirectiveOptions } from 'vue'
import removeCaracteresEspeciais from '@/utils/caracteresEspeciais'

// Escuta em fase de captura no elemento raiz do v-text-field: roda antes do listener do próprio <input>,
// então o Vuetify já lê o valor limpo. Limpar no @input do v-model não basta — se o valor limpo for igual
// ao anterior, o v-text-field não re-renderiza e o caractere continua visível no campo.
const limparCaracteresEspeciais = (event: Event) => {
  const campo = event.target

  if (!(campo instanceof HTMLInputElement) && !(campo instanceof HTMLTextAreaElement)) {
    return
  }

  const valorLimpo = removeCaracteresEspeciais(campo.value)

  if (valorLimpo === campo.value) {
    return
  }

  const posicaoCursor = removeCaracteresEspeciais(campo.value.slice(0, campo.selectionStart || 0)).length

  campo.value = valorLimpo
  campo.setSelectionRange(posicaoCursor, posicaoCursor)
}

const semCaracteresEspeciaisDirective: DirectiveOptions = {
  bind(el) {
    el.addEventListener('input', limparCaracteresEspeciais, true)
  },
  unbind(el) {
    el.removeEventListener('input', limparCaracteresEspeciais, true)
  },
}

export default semCaracteresEspeciaisDirective
